// extracted by mini-css-extract-plugin
module.exports = {"block":"block--2awKU","divider":"divider--1wUlv","button":"button--cWhwC","wrapper":"wrapper--i-it1","loading":"loading--34nhb","container":"container--Xb7Oz","rotated":"rotated--Mvlud","filler":"filler--37S2l","withGallery":"withGallery--3b8tR","gallery":"gallery--jBUKK","active":"active--1beCx"};
    if(module.hot) {
      // 1732531524475
      var cssReload = require("/home/kartik/kvr-lsf/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"esModule":false,"modules":{"namedExport":false},"locals":true});
      module.hot.dispose(cssReload);
      
    }
  